import { render, staticRenderFns } from "./MedicaidEligibility.vue?vue&type=template&id=2c0f4d2a&scoped=true"
import script from "./MedicaidEligibility.vue?vue&type=script&lang=js"
export * from "./MedicaidEligibility.vue?vue&type=script&lang=js"
import style0 from "./MedicaidEligibility.vue?vue&type=style&index=0&id=2c0f4d2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0f4d2a",
  null
  
)

export default component.exports